import tw from 'twin.macro'

export const TwMainGridWrapper = tw.div`grid grid-cols-1 gap-6 p-2.5 lg:p-6 md:grid-cols-12`
export const TwLableForm = tw.label`mb-2 block text-sm font-semibold text-gray-700`
